import {
  buildSmarPanelAccessMonitorResultsUrl,
  getSmarPanelCurrentPortalPageUrl,
} from './smarPanelAccessMonitor';

export const SMARPANEL_MOZILLA_OBSERVATORY_ANALYZE_BASE_URL =
  'https://developer.mozilla.org/en-US/observatory/analyze';

export const SMARPANEL_MOZILLA_OBSERVATORY_HOME_URL =
  'https://developer.mozilla.org/en-US/observatory';

export const SMARPANEL_SECURITY_HEADERS_SCAN_BASE_URL =
  'https://securityheaders.com/';

export function buildSmarPanelMozillaObservatoryEvaluationUrl(pageUrl) {
  if (!pageUrl) return SMARPANEL_MOZILLA_OBSERVATORY_HOME_URL;

  try {
    const { hostname } = new URL(pageUrl);
    const params = new URLSearchParams({ host: hostname });

    return `${SMARPANEL_MOZILLA_OBSERVATORY_ANALYZE_BASE_URL}?${params.toString()}`;
  } catch {
    return SMARPANEL_MOZILLA_OBSERVATORY_HOME_URL;
  }
}

export function buildSmarPanelSecurityHeadersEvaluationUrl(pageUrl) {
  if (!pageUrl) return SMARPANEL_SECURITY_HEADERS_SCAN_BASE_URL;

  const params = new URLSearchParams({
    q: pageUrl,
    followRedirects: 'on',
  });

  return `${SMARPANEL_SECURITY_HEADERS_SCAN_BASE_URL}?${params.toString()}`;
}

export function buildSmarPanelToolEvaluationUrls(pageUrl = getSmarPanelCurrentPortalPageUrl()) {
  return {
    accessmonitor: buildSmarPanelAccessMonitorResultsUrl(pageUrl),
    'mozilla-observatory': buildSmarPanelMozillaObservatoryEvaluationUrl(
      pageUrl
    ),
    'security-headers': buildSmarPanelSecurityHeadersEvaluationUrl(pageUrl),
  };
}
